import {
  BackBar,
  dirhams,
  fullDate,
  receiptsCount,
  startOfToday,
  sumAmounts,
  useSession,
} from '@horof/shared';
import { Alert, Empty, Skeleton } from 'antd';
import { useMemo } from 'react';
import { useQuery } from 'urql';
import { graphql } from './gql';

const TodayPaymentsDocument = graphql(`
  query TodayPayments($since: Datetime!) {
    payments(
      filter: { paymentDate: { greaterThanOrEqualTo: $since } }
      orderBy: [PAYMENT_DATE_DESC]
    ) {
      nodes {
        id
        receiptNo
        amount
        receivedBy
        receiptLink
        bill {
          member {
            fullName
          }
        }
      }
    }
  }
`);

/** Today's payments, to count the cash: everyone's, and the user's own. */
export function TodayPage() {
  const session = useSession();
  const since = useMemo(() => startOfToday(), []);
  const [{ data, error }] = useQuery({
    query: TodayPaymentsDocument,
    variables: { since },
    requestPolicy: 'network-only',
  });
  const payments = (data?.payments?.nodes ?? []).flatMap((p) => (p ? [p] : []));
  const mine = payments.filter((p) => p.receivedBy === session.username);

  return (
    <div className="page">
      <BackBar label="الأعضاء" />
      <h1 className="member-title">مقبوضات اليوم</h1>
      <div className="field-hint">{fullDate(since)}</div>

      {error && <Alert type="error" showIcon message="تعذّر التحميل" />}
      {!data && !error && <Skeleton active />}

      {data && (
        <section className="card today-totals">
          <div>
            <div className="field-label">استلمتَ أنت</div>
            <div className="total-number">
              {dirhams(sumAmounts(mine.map((p) => p.amount)))}
            </div>
            <div className="field-hint">{receiptsCount(mine.length)}</div>
          </div>
          <div>
            <div className="field-label">مجموع الجمعية</div>
            <div className="total-number">
              {dirhams(sumAmounts(payments.map((p) => p.amount)))}
            </div>
            <div className="field-hint">{receiptsCount(payments.length)}</div>
          </div>
        </section>
      )}

      {data && payments.length === 0 && (
        <Empty description="لا توجد أداءات اليوم" />
      )}
      {payments.length > 0 && (
        <ul className="receipt-list card">
          {payments.map((p) => (
            <li key={p.id}>
              <span className="receipt-main">
                <span className="receipt-no">
                  {p.bill?.member?.fullName ?? ''}
                </span>
                <span className="field-hint">
                  {dirhams(p.amount)} · وصل{' '}
                  <span className="ltr-num">{p.receiptNo}</span>
                  {p.receivedBy ? ` · ${p.receivedBy}` : ''}
                </span>
              </span>
              <a href={p.receiptLink} target="_blank" rel="noreferrer">
                الوصل
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
